const management = {
	alert: {
		shutdown:
			"Das Herunterfahren eines VPS kurz nach dem Start kann länger als gewöhnlich dauern oder fehlschlagen. Wenn Sie erneut versuchen möchten, ihn herunterzufahren, klicken Sie bitte erneut auf 'Abschaltung', bis der Vorgang erfolgreich abgeschlossen ist.",
	},
	config: {
		delete: "VPS löschen",
		title: "VPS-Konfiguration",
		update: "VPS bearbeiten",
	},
	general: {
		console: "Konsole öffnen",
		day: "Tag",
		days: "Tage",
		description: "Beschreibung",
		description_updated: "Die Beschreibung Ihres VPS wurde erfolgreich geändert.",
		hostname: "Hostname",
		name: "Name",
		relation: "Beziehung",
		title: "VPS-Informationen",
		uptime: "Betriebszeit",
	},
	notifications: {
		pending:
			"Es liegen Änderungen bereit, die erst nach dem Neustart Ihres Geräts angewendet werden.",
		update: "Die Änderungen für VPS <strong>{{name}}</strong> werden verarbeitet...",
		update_active:
			"Derzeit wird die VPS-Konfiguration aktualisiert. Bevor Sie Änderungen vornehmen, müssen Sie Ihren VPS neu starten.",
	},
	pending_dialog: {
		description:
			"Hier sind die Änderungen aufgeführt, die erst nach dem Neustart Ihres Geräts angewendet werden können.",
		reboot_button: "Neustart",
		title: "Änderungen ausstehend",
	},
	snapshots: {
		available: "verfügbar",
		create: "Snapshot erstellen",
		description: "Snapshot-Informationen",
		dialog_create: {
			description: "Einen neuen Snapshot hinzufügen.",
			expiring_date_first: "Snapshot nach",
			expiring_date_second: "Tagen löschen.",
			name_fail: "Der Name entspricht nicht den Anforderungen.",
			title: "Snapshot hinzufügen",
		},
		dialog_delete: {
			description:
				"Sind Sie sicher, dass Sie den Snapshot <strong>{{name}}</strong> dauerhaft löschen möchten?",
			title: "Snapshot löschen",
		},
		dialog_rollback: {
			description:
				"Der VPS mit allen Daten wird durch den Snapshot <strong>{{name}}</strong> überschrieben.",
			extra_options: {
				alert:
					"Die Anzahl der verfügbaren Snapshots wird um eins erhöht, wenn Sie die obenstehende Option auswählen.",
				option_one: "Erstellen Sie vorher einen Snapshot des aktuellen Status.",
				title: "Zusätzliche Optionen",
			},
			title: "Snapshot wiederherstellen",
		},
		from: "von ",
		last_made: "Zuletzt erstellter Snapshot",
		not_available_button:
			"Keine Snapshots verfügbar. Klicken Sie hier, um Schnappschüsse einzurichten",
		not_found: "Keine Schnappschüsse gefunden.",
		not_found_button:
			"Keine Schnappschüsse gefunden. Klicken Sie hier, um Schnappschüsse einzurichten",
		title: "Snapshots",
	},
	ssh: {
		description:
			"Hier sind die SSH-Schlüssel aufgeführt, die bei der Erstellung des VPS mit diesem VPS verknüpft sind. Dies ist nicht in Echtzeit.",
		expired: {
			description:
				"Die SSH-Schlüssel werden bis zu 31 Tage nach der Erstellung eines VPS angezeigt. Nach Ablauf dieser Frist können sie nur noch direkt beim VPS angefordert werden, um Desinformationen zu verhindern.",
			title: "Die SSH-Schlüssel werden hier nicht mehr angezeigt.",
		},
		not_found: "Keine SSH-Schlüssel gefunden.",
	},
	title: "VPS-Informationen",
};

export default management;
